import React from 'react';

import PriceFilterV2 from '../PriceFilterV2/PriceFilterV2';
import RoomsAndSpacesFilter from '../RoomsAndSpacesFilter/RoomsAndSpacesFilter';
import FreeCancellationFilter from '../FreeCancellationFilter/FreeCancellationFilter';
import FilterGroupFilters from '../FilterGroupFilters/FilterGroupFilters';

import {Props as FilterGroupFiltersProps} from '../FilterGroupFilters/FilterGroupFilters';
import {Props as FilterBarProps} from '../FilterBarV2/FilterBarV2';
import {
    PRICE_FILTER_GROUP_ID,
    ROOMSANDSPACES_FILTER_GROUP_ID,
    FREE_CANCELLATION_GROUP_ID,
} from '../../constants/filters';

export type ExtendedProps = Pick<
    FilterBarProps,
    | 'currency'
    | 'customFiltersParams'
    | 'isMobile'
    | 'onCustomFilterUpdate'
    | 'onFilterToggle'
    | 'onMultipleFilterToggle'
    | 'priceFilterOptions'
    | 'priceInputValuesAreValid'
    | 'results'
    | 'selectedFilters'
    | 'updatePriceInputValuesValidity'
>;
export interface Props extends ExtendedProps, FilterGroupFiltersProps {
    isGroupOpen: boolean;
}

export default function FilterGroupContent({
    currency,
    customFiltersParams,
    filters,
    groupId,
    isGroupOpen,
    isMobile,
    onCustomFilterUpdate,
    onFilterToggle,
    onMultipleFilterToggle,
    priceFilterOptions,
    priceInputValuesAreValid,
    selectedFilters,
    twoColumns,
    updatePriceInputValuesValidity,
}: Props) {
    // Return content based on filter group.
    if (groupId === PRICE_FILTER_GROUP_ID) {
        return (
            <PriceFilterV2
                currency={currency}
                customFiltersParams={customFiltersParams}
                onCustomFilterUpdate={onCustomFilterUpdate}
                priceFilterOptions={priceFilterOptions}
                priceInputValuesAreValid={priceInputValuesAreValid}
                updatePriceInputValuesValidity={updatePriceInputValuesValidity}
            />
        );
    }

    if (groupId === ROOMSANDSPACES_FILTER_GROUP_ID) {
        return (
            <RoomsAndSpacesFilter
                customFiltersParams={customFiltersParams}
                filters={filters}
                isMobile={isMobile}
                onCustomFilterUpdate={onCustomFilterUpdate}
                onFilterToggle={onFilterToggle}
                resetViewAll={isGroupOpen}
                selectedFilters={selectedFilters}
                twoColumns={twoColumns}
            />
        );
    }

    if (groupId === FREE_CANCELLATION_GROUP_ID) {
        return (
            <FreeCancellationFilter
                filters={filters}
                onMultipleFilterToggle={onMultipleFilterToggle}
                selectedFilters={selectedFilters}
            />
        );
    }

    return (
        <FilterGroupFilters
            filters={filters}
            groupId={groupId}
            selectedFilters={selectedFilters}
            onFilterToggle={onFilterToggle}
            resetViewAll={isGroupOpen}
            isMobile={isMobile}
            twoColumns={twoColumns}
        />
    );
}
